import React, { useEffect, useState } from 'react';
import { configData } from "../config";
import './classes/CourseFields.css';

// The site names of the URL Restriction field, as the live site lists them
const urlRestrictionLabel = (domain) => {
    if (/agency/i.test(domain)) return "SMWWAgency.com";
    if (/scout/i.test(domain)) return "SMWWScout.com";
    return "SportsManagementWorldwide.com";
};
// Stored as one domain (migrated pages) or a JSON list (pages saved here)
const urlRestrictions = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    try {
        const list = JSON.parse(value);
        if (Array.isArray(list)) return list;
    } catch (e) { /* a single domain */ }
    return String(value).split(',').map((domain) => domain.trim()).filter(Boolean);
};

// The course's own fields under its body, which the live site shows to admins only: label above,
// value under it, in the order of the live page.
const CourseFields = ({ page }) => {
    // The picture's address comes with the page as admins edit it (coursepages/geteditpagedata)
    const [image, setImage] = useState(null);
    useEffect(() => {
        setImage(null);
        if (!page?.field_image_fid || !page?.url_slug) return;
        let cancelled = false;
        fetch(configData.APP_URL + 'coursepages/geteditpagedata?path=' + encodeURIComponent(page.url_slug))
            .then((response) => response.json())
            .then((data) => { if (!cancelled && data?.data?.field_image?.url) setImage(data.data.field_image.url); })
            .catch(() => {});
        return () => { cancelled = true; };
    }, [page?.field_image_fid, page?.url_slug]);

    const text = (value) => (value === null || value === undefined ? '' : String(value).trim());
    const fields = [
        { name: 'apply-form-desc', label: 'Description for Preview Tile', values: [text(page?.field_apply_form_desc)] },
        { name: 'application-key-name', label: 'Application Key Name', values: [text(page?.field_application_key_name)] },
        {
            name: 'image', label: 'Image', image: true,
            values: [image ? <img src={image} width={page?.field_image_width || undefined} height={page?.field_image_height || undefined} alt={page?.field_image_alt || ''} /> : '']
        },
        { name: 'meta-keywords', label: 'Meta Keywords', values: [text(page?.field_meta_keywords)] },
        { name: 'meta-description', label: 'Meta Description', values: [text(page?.field_meta_description)] },
        { name: 'meta-title', label: 'Meta Title', values: [text(page?.field_meta_title)] },
        { name: 'weight', label: 'Weight (lbs)', values: [text(page?.field_weight)] },
        { name: 'url-restriction', label: 'URL Restriction', values: urlRestrictions(page?.field_url_restriction).map(urlRestrictionLabel) },
    ].map((field) => ({ ...field, values: field.values.filter((value) => value !== '') }))
     .filter((field) => field.values.length > 0);

    if (!fields.length) return null;
    return (
        <div className="course-fields">
            {fields.map((field) => (
                <div key={field.name} className={'course-field course-field-' + field.name + (field.image ? ' course-field-type-image' : '')}>
                    <div className="course-field-label">{field.label}:&nbsp;</div>
                    {field.values.map((value, index) => (
                        <div key={index} className="course-field-item">{value}</div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default CourseFields;
